module.exports = __webpack_public_path__ + "media/react/assets/TotalGoals-181ad485d0bc677e02543b9b0370e0dd.svg";